
import React from 'react';

const CoursesSection: React.FC = () => {
  const courses = [
    {
      icon: 'ri-emotion-happy-line',
      title: '笑顔創生コース（起業準備）',
      description: '笑顔で人々を幸せにするビジネスを創造し、起業家として成功するためのスキルを習得',
      color: 'bg-yellow-500',
      features: ['起業実践', 'ビジネスプラン作成', '笑顔マーケティング', 'リーダーシップ', '資金調達']
    },
    {
      icon: 'ri-fire-line',
      title: '万バズ、ヒットメーカーコース（SNS対策）',
      description: 'SNSで話題を生み出し、影響力のあるコンテンツクリエイターを目指すコース',
      color: 'bg-red-500',
      features: ['コンテンツ制作', 'SNS戦略', 'インフルエンサー育成', 'バイラルマーケティング', 'ブランディング']
    },
    {
      icon: 'ri-robot-line',
      title: 'AI、自動化コース（テクノロジー）',
      description: '最新のAI技術と自動化システムを学び、未来のテクノロジーリーダーを育成',
      color: 'bg-blue-500',
      features: ['AI開発', 'プログラミング', '自動化システム', 'データ分析', 'IoT技術']
    },
    {
      icon: 'ri-mic-line',
      title: '芸能',
      description: 'エンターテインメント業界で活躍するための表現力とパフォーマンススキルを磨く',
      color: 'bg-purple-500',
      features: ['演技指導', 'ダンス', '歌唱', 'オーディション対策', 'メディア出演']
    },
    {
      icon: 'ri-earth-line',
      title: '留学、英語',
      description: 'グローバル社会で活躍するための語学力と国際感覚を身につける',
      color: 'bg-green-500',
      features: ['英語習得', '留学準備', '国際交流', 'TOEIC対策', '異文化理解']
    },
    {
      icon: 'ri-scissors-line',
      title: '美容、ファッション',
      description: '美容とファッション業界のプロフェッショナルとして活躍するためのスキルを習得',
      color: 'bg-pink-500',
      features: ['美容技術', 'ファッションデザイン', 'スタイリング', 'トレンド分析', 'ブランド企画']
    }
  ];

  return (
    <section id="courses" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            コース一覧
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            あなたの未来を創る道がここにある
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group border border-gray-100 hover:border-gray-200"
            >
              {/* アイコン */}
              <div className={`w-20 h-20 ${course.color} rounded-full flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${course.icon} text-4xl text-white`}></i>
              </div>

              {/* タイトル */}
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">
                {course.title}
              </h3>

              {/* 説明 */}
              <p className="text-gray-600 leading-relaxed mb-6 text-center text-sm">
                {course.description}
              </p>

              {/* 特徴 */}
              <div className="space-y-2 mb-6">
                {course.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center">
                    <div className={`w-2 h-2 ${course.color} rounded-full mr-3`}></div>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </div>
                ))}
              </div>

              {/* 詳細ボタン */}
              <div className="text-center">
                <button className="text-blue-600 hover:text-blue-800 font-medium cursor-pointer flex items-center justify-center mx-auto gap-1 group-hover:gap-2 transition-all duration-300 text-sm whitespace-nowrap">
                  詳細を見る
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 mb-6">
            どのコースがあなたに最適か迷っていませんか？
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            個別相談でコース選択をサポート
          </button>
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
